import { useState } from "react";
import FuelTransactions from "@/components/fuel/FuelTransactions";
import FuelCars from "@/components/fuel/FuelCars";
import ReportF1 from "@/components/fuel/ReportF1";
import HelpButton from "@/components/HelpButton";

const VIEWS = [
  { key: "transactions", label: "Tranzacții" },
  { key: "cars", label: "Mașini & centre de cost" },
  { key: "f1", label: "F1 · Distribuție pe centre de cost" },
];

export default function Fuel() {
  const [view, setView] = useState("transactions");

  return (
    <div className="space-y-5">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Carburanți</h1>
          <HelpButton anchor={view === "f1" ? "f1" : "tranzactii"} />
        </div>
        <p className="text-sm text-slate-500">Tranzacții OMV repartizate pe centre de cost, cu bonus lunar.</p>
      </div>

      <div className="flex flex-wrap gap-1">
        {VIEWS.map((v) => (
          <button key={v.key} data-testid={`fuel-view-${v.key}`} onClick={() => setView(v.key)}
            className={`px-3 py-1.5 text-xs font-semibold rounded transition-colors ${view === v.key ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
            {v.label}
          </button>
        ))}
      </div>

      <div key={view}>
        {view === "transactions" && <FuelTransactions />}
        {view === "cars" && <FuelCars />}
        {view === "f1" && <ReportF1 />}
      </div>
    </div>
  );
}
